import { FunctionComponent, memo } from 'react';
import { isAndroid, isIOS } from 'react-device-detect';

import { APPLE_STORE_APP_URL, GOOGLE_PLAY_ACRES_URL } from '@/constants/urls';

import Button, { ButtonSize, ButtonVariant } from '..';

const AppDownloadButton: FunctionComponent = () => {
  let appStoreUrl = '';

  if (isAndroid) {
    appStoreUrl = GOOGLE_PLAY_ACRES_URL;
  } else if (isIOS) {
    appStoreUrl = APPLE_STORE_APP_URL;
  }

  return (
    <a href={appStoreUrl}>
      <Button
        className="h-7 border-white text-white"
        size={ButtonSize.SMALL}
        variant={ButtonVariant.SECONDARY_BLACK}
      >
        Download
      </Button>
    </a>
  );
};

export default memo(AppDownloadButton);
